import { Layout } from 'antd'
import { useAuth } from 'AuthContext';
import StudentSendFeedback from 'components/general/StudentSendFeedback';
import React from 'react'
import { Link } from 'react-router-dom';

const openModelObj = {};

export default function Footer() {
    const { user } = useAuth();
    return <div>
        <Layout.Footer style={{ padding: 0 }}>
            {/* <div style={{
                backgroundSize: "cover",
                backgroundColor: "rgb(0 16 28)",
                backgroundImage: `url(${`${process.env.PUBLIC_URL}/img/bgfooter.png`})`,
                padding: 10
            }}>
            </div> */}
            <div style={{ textAlign: 'center', }}>
                {user && <><span style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                }} onClick={()=>openModelObj.setOpenFeedback && openModelObj.setOpenFeedback(true)}>
                    Đóng góp ý kiến
                </span><br />
                <Link to="/tutorial" style={{ color: "white", textDecoration: "underline", }}>
                    Hướng dẫn sử dụng
                </Link><br />
                </>}
                Copyright {new Date().getFullYear()} © hoctot.ai
            </div>
            {user && <StudentSendFeedback openModelObj={openModelObj} />}
        </Layout.Footer>
    </div>
}
